export default __webpack_public_path__ + "static/media/icon-fuel.f3be5a7b.svg";